import { ControlsState } from '@shared/components/filter/types';
import { createCtx } from '@shared/util/context';

interface BulkUpdateState {
  totalCardCount: number;
  showBulkFilterUpdate: boolean;
  setShowBulkFilterUpdate: (showBulkFilterUpdate: boolean) => void;
  isLoading: boolean;
  showBulkFilterUpdateForm: boolean;
  setShowBulkFilterUpdateForm: (showBulkFilterUpdateForm: boolean) => void;
  controlsState: ControlsState;
  setControlsState: (controlState: ControlsState) => void;
  workspaceName: string;
}

export const [useBulkUpdateState, BulkUpdateStateProvider] = createCtx<BulkUpdateState>();
